import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const EFFECTIVE_DATE = "February 14, 2026";

const Section = ({ title, children }) => (
  <section className="space-y-2">
    <h2 className="text-2xl font-bold text-white">{title}</h2>
    <div className="text-gray-300 leading-relaxed space-y-2">{children}</div>
  </section>
);

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen" style={{ background: "#1a1a1e" }} data-testid="privacy-policy-page">
      <div className="border-b border-gray-800" style={{ background: "#0f0f11" }}>
        <div className="container-custom py-4">
          <Link to="/"><Button variant="ghost" className="text-purple-400" data-testid="privacy-back">← Back</Button></Link>
        </div>
      </div>
      <div className="container-custom py-12">
        <div className="max-w-4xl mx-auto">
          <Card className="p-8" style={{ background: "rgba(42, 26, 58, 0.5)", borderColor: "rgba(138, 43, 226, 0.3)" }}>
            <h1 className="text-4xl font-bold text-white mb-2">Privacy Policy</h1>
            <p className="text-sm text-purple-300 mb-8" data-testid="privacy-effective-date">Effective Date: {EFFECTIVE_DATE}</p>
            <div className="space-y-6">
              <p className="text-gray-300 leading-relaxed">
                RGM Studio respects your privacy and is committed to protecting your personal information.
              </p>

              <Section title="Information We Collect">
                <p>We may collect:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>name and email address</li>
                  <li>profile information</li>
                  <li>uploaded music, images, and creator content</li>
                  <li>device and usage information</li>
                </ul>
              </Section>

              <Section title="How We Use Information">
                <p>We use collected information to:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>provide app features and services</li>
                  <li>improve user experience</li>
                  <li>manage accounts and uploads</li>
                  <li>communicate important updates</li>
                  <li>support creator discovery and engagement systems</li>
                </ul>
              </Section>

              <Section title="Content Uploads">
                <p>Users may upload:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>music</li>
                  <li>cover art</li>
                  <li>profile images</li>
                  <li>videos</li>
                  <li>creator content</li>
                </ul>
                <p>through the platform.</p>
              </Section>

              <Section title="Data Protection">
                <p>RGM Studio takes reasonable measures to help protect:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>user information</li>
                  <li>creator uploads</li>
                  <li>account security</li>
                  <li>platform integrity</li>
                </ul>
              </Section>

              <Section title="Third-Party Services">
                <p>RGM Studio may use trusted third-party services for:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>analytics</li>
                  <li>hosting</li>
                  <li>authentication</li>
                  <li>storage</li>
                  <li>payment processing</li>
                  <li>app functionality</li>
                </ul>
              </Section>

              <Section title="Children's Privacy">
                <p>RGM Studio is not intended for children under 13 years old.</p>
              </Section>

              <Section title="Community Standards">
                <p>Users may not upload or distribute:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>illegal content</li>
                  <li>hate speech</li>
                  <li>harassment</li>
                  <li>scams</li>
                  <li>explicit harmful material</li>
                  <li>copyrighted content they do not own or have permission to use</li>
                </ul>
                <p>
                  RGM Studio reserves the right to remove violating content and suspend accounts that break
                  platform rules.
                </p>
              </Section>

              <Section title="Contact">
                <p>📧 <a className="text-purple-300 underline" href="mailto:realglobalmusicent@yahoo.com">realglobalmusicent@yahoo.com</a></p>
                <p>🌐 <a className="text-purple-300 underline" href="https://rgmstudio.org">RGMStudio.org</a></p>
              </Section>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
